import { Injectable } from '@angular/core';
import { AuthSession, fetchAuthSession, signOut } from 'aws-amplify/auth';
import { jwtDecode } from 'jwt-decode';
import { catchError, from, map, Observable, throwError } from 'rxjs';
import { Auth } from 'src/app/domain/models/auth.model';
import { AuthPort } from '../../domain/ports/auth.port';
import { UserAttributesMapper } from '../mappers/user-attributes.mapper';
import { UserAttributesModel } from '../models/user-attributes.model';

@Injectable({
  providedIn: 'root',
})
export class AuthAdapter extends AuthPort {
  userAttributesMapper = new UserAttributesMapper();

  override fetchUserAttributes(): Observable<Auth> {
    return this.fetchAuthSession().pipe(
      map((accessToken) => {
        const decodedToken: UserAttributesModel = jwtDecode(accessToken);
        decodedToken['token'] = accessToken;
        return this.userAttributesMapper.mapFrom(decodedToken);
      }),
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }

  override fetchAuthSession(): Observable<string> {
    return from(fetchAuthSession()).pipe(
      map(
        (session: AuthSession) => session.tokens?.accessToken.toString() || ''
      ),
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }

  override signOut(): Observable<void> {
    return from(signOut()).pipe(
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }
}
